/* ============================================================
   BNDT HOME PAGE JS
   ============================================================ */

(function() {
  'use strict';

  /* --- Horizontal scroll for reviews --- */
  function initReviewsScroll() {
    var scroll = document.querySelector('.home-reviews__scroll');
    if (!scroll) return;

    var isDown = false;
    var startX, scrollLeft;

    scroll.addEventListener('mousedown', function(e) {
      isDown = true;
      scroll.style.cursor = 'grabbing';
      startX = e.pageX - scroll.offsetLeft;
      scrollLeft = scroll.scrollLeft;
    });

    scroll.addEventListener('mouseleave', function() {
      isDown = false;
      scroll.style.cursor = 'grab';
    });

    scroll.addEventListener('mouseup', function() {
      isDown = false;
      scroll.style.cursor = 'grab';
    });

    scroll.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - scroll.offsetLeft;
      var walk = (x - startX) * 1.5;
      scroll.scrollLeft = scrollLeft - walk;
    });
  }

  /* --- Animate sections on scroll --- */
  function initScrollAnimations() {
    var sections = document.querySelectorAll(
      '.home-hero, .home-trust-bar, .home-featured, .home-sweep-callout, .home-editorial, .home-reviews, .home-instagram'
    );

    if (!sections.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(function(section) {
      observer.observe(section);
    });
  }

  /* --- Quick Add to Cart (Featured Collection) --- */
  function initQuickAdd() {
    /* Swatch variant picker */
    document.querySelectorAll('.home-featured__variant-picker').forEach(function(picker) {
      picker.addEventListener('click', function(e) {
        var btn = e.target.closest('.home-featured__swatch-btn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        /* Update active swatch */
        picker.querySelectorAll('.home-featured__swatch-btn').forEach(function(s) { s.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var card = btn.closest('.home-featured__card');
        var atcBtn = card.querySelector('.home-featured__atc-btn');
        var priceEl = card.querySelector('.home-featured__price-current');
        var img = card.querySelector('.home-featured__card-image img');

        /* Update ATC button variant */
        atcBtn.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
        var available = btn.getAttribute('data-variant-available') === 'true';
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
        atcBtn.classList.remove('is-added');

        /* Update price */
        if (priceEl && btn.getAttribute('data-variant-price')) {
          priceEl.textContent = btn.getAttribute('data-variant-price');
        }

        /* Update image */
        var variantImg = btn.getAttribute('data-variant-img');
        if (img && variantImg) {
          img.src = variantImg;
        } else if (img && img.getAttribute('data-default-src')) {
          img.src = img.getAttribute('data-default-src');
        }
      });
    });

    /* Add to Cart buttons */
    document.querySelectorAll('.home-featured__atc-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled || btn.classList.contains('is-adding')) return;

        var variantId = btn.getAttribute('data-variant-id');
        btn.classList.add('is-adding');
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          btn.textContent = 'Added!';

          /* Update cart count */
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var badge = document.querySelector('.site-nav__cart-count');
            if (badge) {
              badge.textContent = cart.item_count;
              badge.style.display = cart.item_count > 0 ? '' : 'none';
            }
          });

          /* Open cart drawer after short delay */
          setTimeout(function() {
            if (window.BNDT && window.BNDT.openCartDrawer) {
              window.BNDT.openCartDrawer();
            }
          }, 600);

          /* Reset button after 2s */
          setTimeout(function() {
            btn.classList.remove('is-added');
            btn.textContent = 'Add to Cart';
          }, 2000);
        })
        .catch(function() {
          btn.classList.remove('is-adding');
          btn.textContent = 'Add to Cart';
        });
      });
    });
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function() {
    initReviewsScroll();
    initScrollAnimations();
    initQuickAdd();
  });

})();
